import { Injectable } from '@angular/core';

const UUID_PATTERNS = {
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
};

@Injectable()
export class ValidatorService {
  isUUID(str: string): boolean {
    const pattern = UUID_PATTERNS['all'];
    return pattern && pattern.test(str);
  }
}
